const ENFinalncialManagement = {
	"Acesso análises": "Access analysis",
	"Acesso orçamentos": "Access budgets",
	"Acesso orçamentos e análises": "Access budgets and analysis",
	"Adicionar plano orçamentário": "Add budget plan",
	"Alterar plano orçamentário": "Change budget plan",
	"Arquivos processados. Verifique o status da integração.": "Files processed. Check integration status.",
	"Cód. Canal de vendas": "Sales channel code",
	"Cód. Centro de custo": "Center cost code",
	"Cód. Conta": "Account code",
	"Cód. Custo variável": "Variable costs code",
	"Cód. Dedução de vendas": "Saled deduction code",
	"Cód. Despesa variável": "Variable expense code",
	"Cód. Integ. Centro de Custo": "Center cost integ. code",
	"Cód. Integ. Conta": "Account integ. code",
	"Cód. Linha de produtos": "Product line code",
	"Cód. Outras contas": "Other accounts code",
	"Cód. Unidade/Filial": "Unit/Subsidiary code",
	"Consulta": "Query",
	"Controle total": "Total control",
	"Copiar plano orçamentário": "Copy budget plan",
	"Data edição planejado": "Edition date planned",
	"Data edição realizado": "Edition date realized",
	"Dedução de vendas": "Sales deduction",
	"Deseja realmente excluir o plano orçamentário": "Do you really want to delete the budget plan",
	"Digite o nome do plano orçamentário para excluí-lo": "Type the name of the budget plan to delete it",
	"Erro ao adicionar plano orçamentário": "Error adding budget plan",
	"Erro ao alterar plano orçamentário": "Error changing budget plan",
	"Erro ao buscar planos orçamentários": "Error on searching budget plans",
	"Erro ao buscar plano orçamentário": "Error on searching budget plan",
	"Erro ao copiar plano orçamentário": "Error copying budget plan",
	"Erro ao excluir plano orçamentário": "Error deleting budget plan",
	"Erro ao integrar valores": "Error integrating values",
	"Exclusão do plano orçamentário": "Delete budget plan",
	"Integrar valores realizados": "Integrate realized values",
	"Moeda é requerida": "Coin is required",
	"Não copiar": "Do not copy",
	"Não foi possível encontrar o plano orçamentário, volte para a tela de planos orçamentários e selecione novamente": "Cannot find budget plan, go back to budget plans screen and select again",
	"Nome do plano orçamentário não confere": "Budget plan names doesn't match",
	"Nome deve conter no máximo 100 caracteres": "Name must contain a maximum of 100 characters",
	"Novo plano orçamentário": "New budget plan",
	"Painel Plano Orçamentário": "Budget Plan Panel",
	"Plano orcamentário adicionado com sucesso": "Budget plan successfully added",
	"Plano orcamentário alterado com sucesso": "Budget plan successfully changed",
	"Plano orcamentário copiado com sucesso": "Budget plan successfully copied",
	"Plano orçamentário excluído com sucesso": "Budget plan successfully deleted",
	"Selecione um plano orçamentário ao lado": "Select a budget plan on the side",
	"Utiliza conversão de moeda": "Uses currency conversion",
	"Valor planejado": "Planned value",
	"Valor total": "Total value",
	"Valores corporativos desatualizados": "Outdated corporative values",
	"Valores integrados com sucesso": "Successfully integrated values"
};

export default ENFinalncialManagement;
